<div fxLayout="row" fxLayoutAlign="center" class="mt-2">
    <div fxFlex="100" fxFlex.gt-sm="1 1 400px" fxFlex.sm="1 1 400px" class="mat-elevation-z6 p-3">
        <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
            <span *ngIf="provider==enumProviderTypes.Pelecard" class="logo-pelecard"></span>
            <span *ngIf="provider==enumProviderTypes.Bit" class="logo-bit"></span>

            <mat-form-field *ngIf="provider==enumProviderTypes.Pelecard" class="w-100">
                <mat-label>{{ 'PAYMENT.TERMINAL' | translate }} <span class="accent-color">*</span></mat-label>
                <mat-select placeholder="{{ 'PAYMENT.TERMINAL' | translate }}*" formControlName="TerminalID">
                    <mat-option *ngFor="let currentTerminal of terminals" [value]="currentTerminal.ID">
                        {{currentTerminal.Name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="f.TerminalID.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
                <mat-error *ngIf="f.TerminalID.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="provider==enumProviderTypes.Pelecard" class="w-100">
                <mat-label>{{ 'PAYMENT.PAYMENT-BOX' | translate }}</mat-label>
                <mat-select placeholder="{{ 'PAYMENT.PAYMENT-BOX' | translate }}*" formControlName="PaymentBoxID">
                    <mat-option>   </mat-option>
                    <mat-option *ngFor="let currentBox of paymentBoxes" [value]="currentBox.ID">
                        {{currentBox.Name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="f.PaymentBoxID.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>{{ 'PAYMENT.AMOUNT-TO-PAY' | translate }} <span class="accent-color">*</span></mat-label>
                <input matInput type="number" class="price" placeholder="0.00" formControlName="Total" (change)="onPriceChange($event)">
                
                <span matSuffix [innerHTML]="defaultCurrency.HtmlSymbol"><span class="accent-color">*</span></span>
                <mat-error *ngIf="f.Total.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
                <mat-error *ngIf="form.controls.Total.hasError('min')">
                    {{ 'ERROR.MINPRICE' | translate: { 'min': '0.01'} }}
                    <span [innerHTML]="defaultCurrency.HtmlSymbol"></span>
                </mat-error>
                <mat-error *ngIf="form.controls.Total.hasError('max')">
                    {{ 'ERROR.MAXPRICE' | translate: { 'max': '99,999.99'} }}
                    <span [innerHTML]="defaultCurrency.HtmlSymbol"></span>
                </mat-error>
            </mat-form-field>


            <mat-form-field *ngIf="provider==enumProviderTypes.Pelecard" class="w-100">
                <mat-label>{{ 'PAYMENT.MAX-NUMBER-OF-PAYMENT' | translate }}</mat-label>
                <input matInput type="number"  placeholder="1" formControlName="MaxNumberOfPayments">                
                
                <mat-error *ngIf="f.MaxNumberOfPayments.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
                <mat-error *ngIf="form.controls.MaxNumberOfPayments.hasError('min')">
                    {{ 'ERROR.MINVALUE' | translate: { 'min': '1'} }}                   
                </mat-error>
                <mat-error *ngIf="form.controls.MaxNumberOfPayments.hasError('max')">
                    {{ 'ERROR.MAXVALUE' | translate: { 'max': '48'} }}                  
                </mat-error>
            </mat-form-field>


            <mat-error *ngIf="error" fxLayoutAlign="center" class="w-100 pb-3 alert alert-danger">{{error}}</mat-error>
            <div fxLayoutAlign="center" class="w-100">

                <button mat-raised-button color="accent" class="mat-elevation-z6 ml-3 send" type="submit"
                    [disabled]="!form.valid">{{
                    'PAYMENT.SEND-PAYMENT-REQUEST' | translate }}</button>

                <button mat-raised-button class="mat-elevation-z6 ml-3 cancel" type="button" (click)="onCancel($event)">{{
                    'PAYMENT.CANCEL' | translate }}</button>

            </div>

          
             <!-- <div class="w-100" style="word-wrap: break-word;">
                <h1>Diagnostic:</h1>
                <div>{{ diagnostic }}</div>
                <h1>Errors:</h1>
                <div>{{ getFormValidationErrors() }}</div>
            </div> -->

        </form>
    </div>
</div>